import React, { useEffect, useState } from "react";

import { Gallery } from "react-grid-gallery";
import GalleryModal from "../Gallery/GalleryModal";

const shortenFilename = (url) => {
  if(!url) return '';
  const filenames = url.split('/');
  return filenames[filenames.length - 1] || ''
}
const FormImages = (props) => {
  const { values, setFieldValue } = props;
  const [openingModal, setOpeningModal] = useState(false);
  const handleRemoveTalent = (index, event) => {
    event.preventDefault();
    setFieldValue('talent_images', (values.talent_images || []).filter((_, idx) => (idx != index)))
  }
  const handleRemoveProperty = (index, event) => {
    event.preventDefault();
    setFieldValue('property_images', (values.property_images || []).filter((_, idx) => (idx != index)))
  }
  const handleOnSelect = (dd) => {
    if(openingModal === 'featured_image') {
      setFieldValue("featured_image", dd ? dd[0] : null );
    } else if(openingModal) {
      const newImages = [...(values[openingModal] || []), ...(dd || [])];
      setFieldValue(openingModal, newImages);
    }
    setOpeningModal(null);
  };
  useEffect(() => {}, []);

  const talentImages = (values.talent_images || []).map((photo, idx) => ({
    src: photo.image_url,
    caption: photo.caption,
    // thumbnailCaption: shortenFilename(photo.image_url),
    id: photo.id,
    width: 'auto',
    customOverlay: (
      <div className="custom-overlay__caption">
        <a onClick={e => handleRemoveTalent(idx, e)} title={`Delete ${shortenFilename(photo.image_url)}`}>
          <i className="fa fa-times"></i>
        </a>
       
      </div>
    ),    
  }))
  const propertyImages = (values.property_images || []).map((photo, idx) => ({
    src: photo.image_url,
    caption: photo.caption,
    // thumbnailCaption: shortenFilename(photo.image_url),
    id: photo.id,
    width: 'auto',
    customOverlay: (
      <div className="custom-overlay__caption">
        <a onClick={e => handleRemoveProperty(idx, e)} title={`Delete ${shortenFilename(photo.image_url)}`}>
          <i className="fa fa-times"></i>
        </a>       
      </div>
    ),   
  }))
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-picture"></i> Photo Gallery
          </h3>
        </div>
        <div className="row with-forms">
          <div className="col-md-12">
            <p>
              Upload the photos of your business to show it in a more
              interesting way. One picture is worth more than a thousand of
              words. Note that some of galleries might not be displayed,
              depending on the subscription you have for your listing. Please
              make sure that the image is minimum 2048px width.
            </p>
          </div>
          <div className="col-md-12">
            <h4>
              Featured Image
              <sup className="required">*</sup>
            </h4>
            <div className="row">
              <div className="col-md-2">
                <button
                  className="button gray"
                  onClick={(e) => {e.preventDefault(); return setOpeningModal("featured_image")}}
                >
                  Add media
                </button>                
              </div>
              <div className="col-md-10">
                {values.featured_image && <Gallery 
                  enableImageSelection={false}
                  images={[{
                      src: values.featured_image.image_url, 
                      caption: values.featured_image.caption,
                      width: 'auto'
                  }]} 
                />}               
              </div>
            </div>
          </div>
          <div className="col-md-12 margin-top-25">
            <h4>
              Featured Talent
            </h4>
            <div className="row">
              <div className="col-md-2">
                <button
                  className="button gray"
                  onClick={(e) => {e.preventDefault(); return setOpeningModal("talent_images")}}
                >
                  Add media
                </button>                
              </div>
              <div className="col-md-10">
                {values.talent_images && <Gallery 
                  enableImageSelection={false}
                  images={talentImages}
                />} 
              </div>
            </div>
          </div>
          <div className="col-md-12 margin-top-25">
            <h4>
              Property Images
            </h4>
            <div className="row">
              <div className="col-md-2">
                <button
                  className="button gray"
                  onClick={(e) => {e.preventDefault(); return setOpeningModal("property_images")}}
                >
                  Add media
                </button>                
              </div>
              <div className="col-md-10">
                {values.property_images && <Gallery 
                  enableImageSelection={false}
                  images={propertyImages} 
                />} 
              </div>
            </div>
          </div>
        </div>
      </div>
      <GalleryModal
        maxNumberOfFiles={openingModal === 'featured_image' ? 1 : 10}
        isOpen={!!openingModal}
        onCancel={(e) => setOpeningModal(null)}
        onSelectPhoto={handleOnSelect}
      />
    </React.Fragment>
  );
};

export default FormImages;
